import { CopiedPrescription, NotCopiedPrescriptionSummaryItem } from '../copyPrescription.types';

import { CopySummaryRow } from './CopySummaryTable.types';

export const mapToRows = (
   copiedPrescriptions: CopiedPrescription[],
   notCopiedSummaryItems: NotCopiedPrescriptionSummaryItem[]
): CopySummaryRow[] => {
   const copiedRows: CopySummaryRow[] = copiedPrescriptions.map((item) => ({
      id: item.prescriptionId,
      medicineName: item.medicineName,
      count: 1,
      type: 'copied',
      medicineId: 0,
   }));

   const notCopiedRows: CopySummaryRow[] = notCopiedSummaryItems.map((item) => ({
      id: item.medicineId,
      medicineName: item.count > 1 ? `${item.medicineName} x ${item.count}` : item.medicineName,
      count: item.count,
      type: item.replaced ? 'replaced' : 'notCopied',
      medicineId: item.medicineId,
   }));

   return [...copiedRows, ...notCopiedRows];
};
